<div class="app-shell">
  <mat-toolbar *ngIf="showToolbar" class="custom-toolbar" [color]="fg"
    [ngStyle]="{ 'background-color': 'white', 'position': 'relative', 'z-index': 5 }"
    style="max-height:36px;font-size:small">
    <!-- The mark for whichever site this is. One build serves more than one domain, so the
         file is named in assets/env.js rather than compiled in: see brandLogo below. The
         bull is what shows when nothing says otherwise. -->
    <img [src]="brandLogo" [alt]="brandAlt" class="baja-brand-logo"
      style="width:26px;height:26px;margin-right:8px;vertical-align:middle;flex:0 0 auto;object-fit:contain;" />

    <button mat-icon-button [matMenuTriggerFor]="menu" [disabled]="!isSignedIn"
      [title]="isSignedIn ? 'Menu' : 'Sign in to use the menu'"
      [attr.aria-label]="isSignedIn ? 'Menu' : 'Menu (sign in to use)'">
      <mat-icon>menu</mat-icon>
    </button>

    <a mat-icon-button class="contact-btn" href="mailto:contact@baja.bio?subject=BajaBio%20GeneTx%20Designer"
       title="Contact contact@baja.bio" aria-label="Contact contact@baja.bio">
      <mat-icon>alternate_email</mat-icon>
    </a>

    <!-- Sits after the round icon button so the citation is one click from anywhere in the app.
         Academic users need something to put in a methods section; leaving them to invent a
         reference is how software ends up cited three different ways in the same field. -->
    <!-- Icon rather than a word: the toolbar is narrow and this one has an unambiguous
         glyph. The title carries the name for anyone hovering, and for screen readers. -->
    <button mat-icon-button class="news-btn" (click)="openNewsFromButton()"
            title="The Baja Times" aria-label="The Baja Times">
      <mat-icon>newspaper</mat-icon>
    </button>

    <!-- Between the news and the citation, because it belongs with them: the buttons
         that lead OUT of the app rather than acting on what is in it. Opens in a new tab
         and never closes the workspace -- a tutorial is usually watched beside the thing
         it is about, not instead of it.
         Shown only to the account that authors this material. The page is a static asset
         and the link still works for anyone it is sent to; what is hidden is the standing
         invitation to a page of demos in a header everyone sees. -->
    <button *ngIf="isAuthorAccount" mat-icon-button class="video-btn" (click)="openTutorials()"
            title="Video tutorials" aria-label="Video tutorials">
      <mat-icon>smart_display</mat-icon>
    </button>

    <button mat-icon-button class="cite-btn" (click)="showCite = true"
            title="How to cite BajaBio GeneTx Designer" aria-label="How to cite BajaBio GeneTx Designer">
      <mat-icon>format_quote</mat-icon>
    </button>

    <mat-menu #menu="matMenu">
      <button *ngFor="let b of buttons" (click)="b.click()" mat-menu-item>
        <span>{{ b.label }}</span>
      </button>
    </mat-menu>
    <span style="flex: 1 1 auto" class="flexExpand"></span>

    <!-- Record and play, for the one account that authors demos. Immediately before the
         account chip, so they read as belonging to that person rather than to the app. -->
    <ng-container *ngIf="isAuthorAccount">
      <button mat-icon-button class="rec-btn" (click)="startRecording()"
              title="Record what you do, then emit a script that replays it"
              aria-label="Record a session">
        <mat-icon>fiber_manual_record</mat-icon>
      </button>
      <button mat-icon-button class="play-btn" (click)="playRecording()"
              title="Paste a recorded script and run it" aria-label="Play a recorded script">
        <mat-icon>play_arrow</mat-icon>
      </button>
      <!-- The other kind of recording -- the screen, to a video file -- is in the account
           menu below rather than here. Its controls were sitting on top of the application
           they were recording, which is the one place they must never be. -->
    </ng-container>

    <!-- TUTORIALS, for anyone signed in. A saved recording plays back on the screen in
         front of you, and the library ranks by what that screen currently is -- so the
         button is in the header rather than inside one screen's menus: it is the same
         question wherever it is asked, and the answer is different in each place. -->
    <button *ngIf="oidcUser" mat-icon-button class="tut-btn" (click)="openSavedTutorials()"
            title="Tutorials for what is on screen — they play back here"
            aria-label="Tutorials for this screen">
      <mat-icon>school</mat-icon>
    </button>

    <!-- Signed-in user (OIDC providers): chip + sign-out -->
    <ng-container *ngIf="oidcUser as u">
      <button mat-button class="oidc-chip" [matMenuTriggerFor]="oidcMenu" title="{{ u.email || u.name }}">
        <span class="oidc-avatar" *ngIf="!u.picture">{{ oidcInitials }}</span>
        <img class="oidc-avatar" *ngIf="u.picture" [src]="u.picture" alt="" referrerpolicy="no-referrer" />
        <span class="oidc-name">{{ u.name || u.email }}</span>
      </button>
      <mat-menu #oidcMenu="matMenu">
        <div class="oidc-menu-head" *ngIf="u.email">
          <div class="oidc-menu-name">{{ u.name || u.email }}</div>
          <div class="oidc-menu-email">{{ u.email }}</div>
          <div class="oidc-menu-prov">via {{ u.provider }}</div>
        </div>
        <button mat-menu-item (click)="showClaudeUsage()">
          <mat-icon>insights</mat-icon><span>Credits usage</span>
        </button>
        <!-- SCREEN RECORDING, START AND STOP, IN A MENU. It was a header button with a
             floating badge carrying its own Stop, both of which sat over the part of the
             application being recorded. A menu item covers nothing: it is only on screen
             while the menu is open, and the menu is not what anyone is demonstrating. The
             label says which of the two it will do, read when the menu opens. -->
        <button mat-menu-item *ngIf="isAuthorAccount" (click)="recordVideo()">
          <mat-icon>{{ videoRecording ? 'stop_circle' : 'videocam' }}</mat-icon>
          <span>{{ videoRecording ? 'Stop screen recording' : 'Record screen to video' }}</span>
        </button>
        <button mat-menu-item (click)="oidcSignOut()">
          <mat-icon>logout</mat-icon><span>Sign out</span>
        </button>
      </mat-menu>
    </ng-container>

  </mat-toolbar>

  <!-- "The Baja Times", maximised. Broadsheet styling on purpose: it is a masthead and
       columns, not a modal with a list in it. -->
  <div class="news-backdrop" *ngIf="showNews" (click)="closeNews()">
    <div class="news-paper" (click)="$event.stopPropagation()">
      <!-- Turned-down corner. It sits in the paper frame, not in the scrolling sheet, so it
           stays on the corner instead of sliding away with the text. -->
      <span class="news-fold" aria-hidden="true"></span>
      <div class="news-sheet">
      <div class="news-masthead">
        <!-- The palm sketch, drawn on the newsprint. White is knocked out of the PNG so it
             sits on the paper stock rather than in a white box. -->
        <img class="news-palm" src="assets/img/palm-sketch.png" alt="" aria-hidden="true" />
        <div class="news-title">The Baja Times</div>
        <div class="news-sub">{{ newsDate }} &nbsp;&bull;&nbsp; Genomics Edition</div>
      </div>

      <!-- Says plainly that the app is still coming up. Without it the paper reads as
           something the user opened, and the wait behind it looks like nothing happening. -->
      <div class="news-press" *ngIf="newsIsSplash">
        <span class="news-press-bar"><i></i></span>
        <span class="news-press-text">The presses are running &mdash; loading the editor&hellip;</span>
      </div>

      <div class="news-loading" *ngIf="newsLoading">Setting today's type&hellip;</div>

      <div class="news-body" *ngIf="!newsLoading">
        <div class="news-article" *ngFor="let item of newsItems; let i = index">
          <div class="news-kicker">{{ i === 0 ? 'Lead story' : 'Also today' }}</div>
          <div class="news-headline">{{ item }}</div>
        </div>
        <div class="news-empty" *ngIf="!newsItems.length">
          No dispatches today. The presses are idle.
        </div>

        <!-- Standing features. They run below the day's headlines and give the paper
             something to read while the editor comes up. -->
        <div class="news-article news-feature" *ngFor="let f of featureStories">
          <div class="news-kicker">{{ f.kicker }}</div>
          <div class="news-feature-headline">{{ f.headline }}</div>
          <div class="news-feature-body">{{ f.body }}</div>
        </div>
      </div>

      </div>
      <button class="news-close" (click)="closeNews()">Close</button>
    </div>
  </div>

  <!-- The way through, on both gates: sign-in and checkout. The free tier is a real product,
       not a teaser, so the choice belongs on the pages that stand in front of the editor
       rather than only inside it. -->
  <div class="freeentry" *ngIf="showFreeEntry">
    <button class="freeentry-btn" (click)="goFreeVersion()">Free version (with limited features)</button>
    <span class="freeentry-note">Sign in to continue. Editing is unlimited; designs and off-target searches are metered.</span>
  </div>

  <!-- Free-plan bar, docked at the bottom for anyone without a subscription.
       Bottom rather than top: the editor's menus, toolbar and track labels line the top edge,
       so a bar there covers the controls the user is reaching for. It is not a blocking
       overlay -- the whole point of the free tier is that the editor works. -->
  <div class="freebar" *ngIf="freeBar && !freeBarCollapsed">
    <span class="freebar-chip">{{ freeBar.unverified ? 'FREE PLAN (UNVERIFIED)' : 'FREE PLAN' }}</span>
    <span class="freebar-text">
      <span *ngIf="freeBar.unverified">
        <b>Your subscription could not be verified</b> for the last few minutes, so the free-tier
        allowance applies until it can be. This clears itself as soon as the check succeeds.
      </span>
      <!-- Status only. This used to explain the free tier in full -- what is metered, the
           monthly figure, the reset date and the remaining counts -- every time it was drawn.
           The explanation belongs on the free-use sign-in page, which someone reads once; a
           bar that sits above the editor while you work only needs to say where you stand. -->
      Designs <b>{{ freeBar.design }}/{{ freeBar.designLimit }}</b>
      &nbsp;&middot;&nbsp;
      Off-target <b>{{ freeBar.ot }}/{{ freeBar.otLimit }}</b>
    </span>
    <a class="freebar-cta" href="/subscribe">Subscribe for unlimited</a>
    <button class="freebar-x" (click)="freeBarCollapsed = true" title="Collapse">&#9662;</button>
  </div>

  <!-- Collapsed form: a corner tab that brings it back. It collapses rather than dismissing,
       so the upgrade path stays one click away without a permanent strip of chrome. -->
  <div class="freetab" *ngIf="freeBar && freeBarCollapsed" (click)="freeBarCollapsed = false">
    <span>Free plan &middot; designs {{ freeBar.design }}/{{ freeBar.designLimit }} &middot; off-targets {{ freeBar.ot }}/{{ freeBar.otLimit }}</span>
    <span class="freetab-cta">Subscribe</span>
  </div>

  <!-- Citation card. Plain overlay rather than a MatDialog: it carries no state and no result,
       so a whole dialog component would be more machinery than the content justifies. -->
  <div class="cite-backdrop" *ngIf="showCite" (click)="showCite = false">
    <div class="cite-card" (click)="$event.stopPropagation()">
      <div class="cite-head">
        <div class="cite-title">How to cite BajaBio GeneTx Designer</div>
        <button mat-icon-button class="cite-x" (click)="showCite = false" title="Close">
          <mat-icon>close</mat-icon>
        </button>
      </div>

      <div class="cite-body">

        <div class="cite-block">
          <div class="cite-label">Reference</div>
          <pre class="cite-text">{{ citePlain }}</pre>
          <button mat-button class="cite-copy" (click)="copyCitation(citePlain)">Copy</button>
        </div>

        <div class="cite-block">
          <div class="cite-label">BibTeX</div>
          <pre class="cite-text">{{ citeBibtex }}</pre>
          <button mat-button class="cite-copy" (click)="copyCitation(citeBibtex)">Copy</button>
        </div>

        <div class="cite-foot">
          Jeff Milton &middot; BajaBio &middot; La Jolla, California
          <span class="cite-copied" *ngIf="citeCopied">Copied</span>
        </div>
      </div>
    </div>
  </div>

  <div class="app-content">
    <div *ngIf="!showLJW" class="route-host">
      <router-outlet></router-outlet>
    </div>

  </div>
</div>